module.exports = __webpack_public_path__ + "img/8.501f32d0.jpg";